/** Bounded weapon-ribbon primitives shared with the standalone fitting room. */
export {BladeTrails,TRAIL_CAP,TRAIL_FLOATS} from '../particles/trails';
export {trailLayout} from '../gpu/layouts';
export {trailFragment} from '../shaders/trails';
